export default __webpack_public_path__ + "static/media/2_icon4B.beeed7d0.png";